// Thermostats routes
export default [
  {
    path: 'thermostats',
    name: 'thermostats',
    redirect: 'thermostats/index',
    component: () =>
      import(
        /* webpackChunkName: "thermostats" */ '../views/thermostats/Thermostats.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'thermostatsManagement',
        meta: {
          tabbable: true,
          tableKeys: ['thermostats'],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['thermostatsView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "thermostatsIndex" */ '../views/thermostats/ThermostatsIndex.vue'
          ),
      },
      {
        path: ':thermostatId',
        name: 'thermostatsEdit',
        meta: {
          menuActiveRouteName: 'thermostatsManagement',
          routePermissions: ['thermostatsView', 'thermostatsManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "thermostatsIndex" */ '../views/thermostats/ThermostatsIndex.vue'
          ),
      },
    ],
  },
];
